import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { UploadFileToBucket } from 'src/api/utils/uploadFileToBucket';
import { CompanyVideo } from 'src/features/companyVideos/companyVideos.types';

const companyVideosApiPath = (companyId: string) => `/companies/${companyId}/videos`;

export const getCompanyVideosAPI = async ({
  companyId,
}: {
  companyId: string;
}): Promise<AxiosResponse<CompanyVideo[] & ApiError>> => {
  return instance
    .get<CompanyVideo[]>(companyVideosApiPath(companyId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export type NewCompanyVideo = Pick<CompanyVideo, 'name'>;

export const createCompanyVideoAPI = async ({
  companyId,
  data,
}: {
  companyId: string;
  data: NewCompanyVideo;
}): Promise<AxiosResponse<CompanyVideo & ApiError>> => {
  return instance
    .post<CompanyVideo>(companyVideosApiPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const companyVideoApiPath = (companyId: string, bannerId: string) => `/companies/${companyId}/videos/${bannerId}`;

export const fetchCompanyVideoAPI = async ({
  companyId,
  videoId,
}: {
  companyId: string;
  videoId: string;
}): Promise<AxiosResponse<CompanyVideo & ApiError>> => {
  return instance
    .get<CompanyVideo>(companyVideoApiPath(companyId, videoId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};
export const updateCompanyVideoAPI = async ({
  companyId,
  videoId,
  data,
}: {
  companyId: string;
  videoId: string;
  data: Partial<Omit<CompanyVideo, 'id'>>;
}): Promise<AxiosResponse<CompanyVideo & ApiError>> => {
  return instance
    .post<CompanyVideo>(companyVideoApiPath(companyId, videoId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteCompanyVideoAPI = async ({
  companyId,
  videoId,
}: {
  companyId: string;
  videoId: string;
}): Promise<AxiosResponse<void & ApiError>> => {
  return instance
    .delete(companyVideoApiPath(companyId, videoId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export type UploadVideoImage = (params: {
  companyId: string;
  videoId: string;
  data: { filename: string };
}) => Promise<AxiosResponse<Parameters<UploadFileToBucket>[0]>>;

const companyBannerImageApiPath = (companyId: string, bannerId: string) =>
  `/companies/${companyId}/videos/${bannerId}/images/upload`;

export const uploadVideoImage: UploadVideoImage = async ({ companyId, videoId, data }) => {
  return instance.post(companyBannerImageApiPath(companyId, videoId), data).catch(e => e.response as never);
};
